// extracted by mini-css-extract-plugin
export default {"landingPage":"LandingPage_landingPage__g-Yl4","fillDetailBox":"LandingPage_fillDetailBox__peti6","buttonsDiv":"LandingPage_buttonsDiv__tfEB2"};